<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/complainReasons">اسباب الشكاوى</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <ComplainReasonsForm v-if="!mainLoading && checkAccess('complain_reasons_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
            />
            <ComplainReasonsView v-if="!mainLoading && !checkAccess('complain_reasons_update')" :dataRow="row" />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import ComplainReasonsForm from './form.vue';
import ComplainReasonsView from './view.vue';

export default {
  name: 'ComplainReasonsUpdate',
  components: {
    ComplainReasonsForm, ComplainReasonsView
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'تعديل: ',
      row: null,
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.$http.get(`/api/admin/complains/reasons/retrieve/${this.id}`).then(({data}) => {
        this.row = data.row;
        this.rowTitle += data.row.name;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
  }
}
</script>
